module.exports = __webpack_public_path__ + "img/tear_cover_flat_adhesive_box3.1aa2622c.png";